
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/editorSearch/components/SearchInput/SearchInput.scss.css.virtualfile';
        module.exports = {"inputSuffix":"_inputSuffix_zfinr_1","container":"_container_zfinr_1","clearButton":"_clearButton_zfinr_1","loader":"_loader_zfinr_1"};